import {useState} from 'react';
import List from '@mui/material/List';
import { Typography, Box, Paper, Divider } from '@mui/material';
import RecommendedVisitsListItems from './RecommendedVisitsListItems';
import RecommendedVisitsListItemsDashboard from './RecommendedVisitsListItemsDashboard';
import AnnouncementIcon from '@mui/icons-material/Announcement';

export default function RecommendedVisitsList({ pet = null, mode = 'pet', refreshUpcomingAppointments = null }) {

  const [listEmpty, setListEmpty] = useState(true);

  return(
      <Paper 
        elevation={3} 
        sx={{ 
          p: 2, 
          borderRadius: 2, 
        }}
      >
      <Typography 
        variant="h6" 
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <AnnouncementIcon color="secondary" sx={{ mr: 1 }} />
        Recommendations
      </Typography>
      <Typography variant="body2" color="text.secondary">
        These are recommendations based on pet age and history. Tap to set an appointment for any of these recommendations.
      </Typography>
      <br />
      {listEmpty && mode === 'pet' ? 
        <Divider variant="fullWidth" component="li">
          <Typography variant="caption" color="text.secondary">
            no recommendations for now
          </Typography>
        </Divider>
      : null}
      {mode === 'dashboard' ?
        <RecommendedVisitsListItemsDashboard
          refreshUpcomingAppointments={refreshUpcomingAppointments}
          pet={null}
          mode={mode}
        />
      :
        <Box sx={{
          maxHeight: 300,
          overflow: "auto"
        }}>
          <List >
            <RecommendedVisitsListItems
              refreshUpcomingAppointments={refreshUpcomingAppointments}
              pet={pet}
              mode={mode}
              setListEmpty={setListEmpty}
            />
          </List>
        </Box>
      }
      </Paper>
  );
}     